import { Autoplay, EffectCreative, Navigation, Scrollbar, Swiper } from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/modules/effect-creative/effect-creative.scss';

document.addEventListener('DOMContentLoaded', () => {
    
    const gallery = document.querySelectorAll('.js-gallerySwiper'),
          scrollbar = document.querySelectorAll('.js-scrollbarSwiper');
    
    const galleryCarousel = () => {
        let swiper = [];
        for (let i = 0; i < scrollbar.length; i++) {
            swiper[i] = new Swiper(gallery[i], {
                autoplay: {
                    delay: 4500
                },
                createElements: 1,
                effect: "creative",
                creativeEffect: {
                    prev: {
                       translate: ["-20%", 0, -1],
                    },
                    next: {
                       translate: ["100%", 0, 0],
                    },
                },
                loop: 1,
                modules: [Autoplay, EffectCreative],
                speed: 1500,
            });
        }
    }
    
    const scrollbarCarousel = () => {
        let swiper = [];
        for (let i = 0; i < scrollbar.length; i++) {
            swiper[i] = new Swiper(scrollbar[i], {
                centeredSlides: true,
                centeredSlidesBounds: 1,
                slidesPerView: 'auto',
        	    breakpoints: {
                    769: {
                        centeredSlides: false,
                        slidesOffsetAfter: 20,
                        spaceBetween: 20,
                    },
                },
                modules: [Navigation, Scrollbar],
                navigation: {
                    nextEl: scrollbar[i].parentNode.querySelector('.swiper-button-next'),
                    prevEl: scrollbar[i].parentNode.querySelector('.swiper-button-prev')
                },
                touchMoveStopPropagation: false,
                scrollbar: {
                    el: scrollbar[i].parentNode.querySelector('.swiper-scrollbar'),
                    draggable: true,
                    dragSize: 50,
                    hide: false
                },
                spaceBetween: 16,
                speed: 800
            });
        }
    };

    const videosCarousel = () => {
        const nav = document.querySelector('.c-videos__nav'),
              slides = videos.querySelectorAll('.swiper-slide');

	    const swiper = new Swiper(videos, {
    	    modules: [Navigation],
            breakpoints: {
                1025: {
                }
            },
            navigation: {
                nextEl: '.c-videos .swiper-button-next',
                prevEl: '.c-videos .swiper-button-prev',
            },
            slidesPerView: 'auto',
            speed: 500
        });
        
        let mediaQuery = '(max-width: 1024px)',
            mediaQueryList = window.matchMedia(mediaQuery);
            
        if (slides.length <= 3) {
            nav.style.display = 'none'
            
            mediaQueryList.matches ? nav.removeAttribute('style') : false;
        }
        
        mediaQueryList.addEventListener('change', event => {
            event.matches ? nav.removeAttribute('style') : nav.style.display = 'none';
        })
    };
  
    window.carousels = function() {
        gallery.length > 0 ? galleryCarousel() : false;
        scrollbar.length > 0 ? scrollbarCarousel() : false;
    };

}, false)
